import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash'


const { actions, reducer } = createSlice({
  name: 'contextualHelp',
  initialState: {
    location: null
  },
  reducers: {
    setHelpLocation: (state, { payload }) => ({ ...state, location: payload })
  },
})

export const
  { setHelpLocation } = actions,
  helpLocation = state => get(state, "contextualHelp.location")

export default reducer
